export default __webpack_public_path__ + "static/media/IncorrectAnswer1.911e7977.mp3";